import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { motion } from "framer-motion";

// Стили для Cookie Consent
const CookieConsentContainer = styled(motion.div)`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #ffffff;
  padding: 1rem;
  box-shadow: 0 -4px 6px rgba(0, 0, 0, 0.1);
  z-index: 999;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  @media (min-width: 768px) {
    flex-direction: row;
    justify-content: space-between;
    padding: 1rem 2rem;
  }
`;

const CookieText = styled.p`
  margin: 0 0 1rem 0;
  color: #333;
  font-size: 0.9rem;
  max-width: 800px;

  @media (min-width: 768px) {
    margin: 0 1rem 0 0;
    text-align: left;
  }
`;

const CookieLink = styled.a`
  color: #007aff;
  text-decoration: none;

  &:hover {
    text-decoration: underline;
  }
`;

const CookieButton = styled.button`
  background-color: #007aff;
  color: white;
  border: none;
  padding: 0.5rem 1rem;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.9rem;
  transition: background-color 0.3s ease;
  min-width: 120px;

  &:hover {
    background-color: #0066cc;
  }
`;

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("cookieConsent");
    if (consent !== "accepted") {
      setVisible(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem("cookieConsent", "accepted");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <CookieConsentContainer
      initial={{ y: 100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: 100, opacity: 0 }}
      transition={{ duration: 0.3 }}
    >
      <CookieText>
        Мы используем файлы cookie для улучшения работы сайта. Продолжая
        использовать сайт, вы соглашаетесь с{" "}
        <CookieLink href="/cookie-policy" target="_blank">
          политикой использования cookie
        </CookieLink>
        .
      </CookieText>
      <CookieButton onClick={acceptCookies}>Принять</CookieButton>
    </CookieConsentContainer>
  );
};

export default CookieConsent;